import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.652 28a1 1 0 110-2c2.756 0 5.511.223 8.266.67a4 4 0 013.207 2.853l.622 2.184c.022.078.042.157.06.237.464 2.11-.912 4.187-3.001 4.754a42.496 42.496 0 01-6.09 1.158 1 1 0 01-.22-1.988 40.516 40.516 0 005.786-1.1c1.093-.297 1.798-1.362 1.571-2.395a1.927 1.927 0 00-.03-.118l-.621-2.184a2 2 0 00-1.604-1.427A49.58 49.58 0 0033.652 28zm-4-10c0 2.206 1.793 4 4 4 2.206 0 4-1.793 4-4 0-2.206-1.793-4-4-4-2.206 0-4 1.793-4 4zm-2 0c0-3.312 2.69-6 6-6 3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6-3.312 0-6-2.69-6-6zm-10 22c5.717 0 9.866-.535 12.408-1.573a2 2 0 001.205-2.243l-.778-3.898a5 5 0 00-4.48-4.003C23.796 28.094 21.01 28 17.653 28s-6.143.095-8.356.283a5 5 0 00-4.48 4.003l-.777 3.898a2 2 0 001.205 2.243C7.786 39.465 11.934 40 17.652 40zm0 2c-5.955 0-10.33-.564-13.165-1.722a4 4 0 01-2.41-4.485l.778-3.898a7 7 0 016.272-5.605c2.275-.194 5.116-.29 8.525-.29 3.41 0 6.25.096 8.525.29a7 7 0 016.272 5.605l.777 3.898a4 4 0 01-2.41 4.485C27.984 41.436 23.607 42 17.653 42zm-6-28c0 3.309 2.69 6 6 6 3.309 0 6-2.69 6-6 0-3.309-2.69-6-6-6-3.309 0-6 2.69-6 6zm-2 0c0-4.416 3.587-8 8-8 4.416 0 8 3.587 8 8 0 4.416-3.587 8-8 8-4.416 0-8-3.587-8-8z",
    fill: "currentColor"
  }));
};

var SvgPeople = styled(SvgComponent).withConfig({
  displayName: "People__SvgPeople",
  componentId: "sc-1c6ka2g-0"
})(["", " ", ""], size, color);
export default SvgPeople;